import axios from "axios";

const KEY = "AIzaSyDAO3MgQq1z7VjdRw4kVYbIIZcZ7o4-JK8";

export default axios.create({
  baseURL: "https://www.googleapis.com/youtube/v3",
  params: {
    part: "snippet",
    maxResults: 5,
    key: KEY,
  },
});
